module.exports = __webpack_public_path__ + "img/premiation-12-viagem-dubai-bmw-x4.eb10e656.png";